import { render } from "./HeadstoneItem.vue?vue&type=template&id=0603e46a&scoped=true&ts=true"
import script from "./HeadstoneItem.vue?vue&type=script&lang=ts"
export * from "./HeadstoneItem.vue?vue&type=script&lang=ts"

import "./HeadstoneItem.vue?vue&type=style&index=0&id=0603e46a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0603e46a"]])

export default __exports__